import { mediaCards } from '@/mocks/chiguaData';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8 md:mb-10">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100">
              <i className="ri-play-circle-line text-xl text-accent-600"></i>
            </div>
            <div>
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
                吃瓜视频
              </h2>
              <p className="text-sm text-foreground-500 mt-0.5">热门吃瓜视频精选</p>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 md:gap-5">
          {mediaCards.map((item) => (
            <div
              key={item.id}
              className="group rounded-xl overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-200 transition-colors cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute bottom-2 right-2 bg-black/70 text-white text-xs px-2 py-0.5 rounded">
                  {item.duration}
                </div>
                <div className="absolute top-2 left-2">
                  <span className="inline-block px-2 py-0.5 rounded text-xs font-medium bg-primary-500 text-white">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-white/90 group-hover:bg-white transition-colors">
                    <i className="ri-play-fill text-xl text-primary-600 ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm font-medium text-foreground-900 line-clamp-2 leading-snug mb-2">
                  {item.title}
                </h3>
                <div className="flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-eye-line"></i>
                  <span>{item.views} 次观看</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}